import React from "react";
import CheckboxMarkedCircle from "mdi-material-ui/CheckboxMarkedCircle";

/******************************************************************
 * ##: ChapterProgress
 * Chapter completion indicator (style-v3): a thin accent track with
 * the percentage, or a "Terminado" badge with a green check at 100%.
 * @param {Number} completedPercentage - 0..100
 * @returns {JSX.Element} - the chapter progress row
 * History:
 * 05-07-2026: Rebuilt with the style-v3 track
 ******************************************************************/
const ChapterProgress = ({ completedPercentage }) => {
  if (completedPercentage >= 100) {
    return (
      <div className="chapter-progress-container">
        <span className="chapter-progress-done">
          <CheckboxMarkedCircle className="chapter-progress-done-icon" />
          Terminado
        </span>
      </div>
    );
  }

  return (
    <div className="chapter-progress-container">
      <span className="chapter-progress-pct">{completedPercentage}%</span>
      <span className="chapter-progress-track">
        <span className="chapter-progress-fill" style={{ width: `${completedPercentage}%` }} />
      </span>
    </div>
  );
};

export default ChapterProgress;
